import actions from "../actions";
import { axios, socket } from "../../config/network";
import { Auth } from "../states/Auth";

const AuthReducer = (state = Auth.initial(), action) => {
  try {
    switch (action.type) {
      case actions.LOG_IN:
        setSession(action.payload?.token);

        return Auth.from(true, action.payload?.token, action.payload?.user);

      case actions.LOG_OUT:
        setSession();

        return Auth.from(false);

      case actions.SET_SESSION:
        setSession(action.payload?.token);

        return Auth.from(
          action.payload?.isLoggedIn,
          action.payload?.token,
          action.payload?.user
        );

      default:
        return state;
    }
  } catch (e) {}
};

const setSession = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;

    socket.auth = {
      token: token,
    };
    socket.disconnect().connect();
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

export default AuthReducer;
